import RenderedAudioMessage from '../../components/chat/RenderedAudioMessage';
import RenderedSolvedPuzzleMessage from '../../components/chat/RenderedSolvedPuzzleMessage';
import RenderedEscapedMessage from '../../components/chat/RenderedEscapedMessage';
import RenderedGroupedMessage from '../../components/chat/RenderedGroupedMessage';
import RenderedHintMessage from '../../components/chat/RenderedHintMessage';
import RenderedImageMessage from '../../components/chat/RenderedImageMessage';
import RenderedLoadingMessage from '../../components/chat/RenderedLoadingMessage';
import RenderedTextMessage from '../../components/chat/RenderedTextMessage';
import RenderedCompletedStageMessage from '../../components/chat/RenderedCompletedStageMessage';

export enum MessageType {
  Text = 'text',
  Loading = 'loading',
  Audio = 'audio',
  Image = 'image',
  Grouped = 'grouped',
  Hint = 'hint',
  Escaped = 'escaped',
  Solved_Puzzle = 'solved_puzzle',
  Completed_Stage = 'completed_stage',
}

export const messageComponents: Record<MessageType, React.FC<any>> = {
  [MessageType.Loading]: RenderedLoadingMessage,
  [MessageType.Text]: RenderedTextMessage,
  [MessageType.Audio]: RenderedAudioMessage,
  [MessageType.Image]: RenderedImageMessage,
  [MessageType.Grouped]: RenderedGroupedMessage,
  [MessageType.Hint]: RenderedHintMessage,
  [MessageType.Escaped]: RenderedEscapedMessage,
  [MessageType.Solved_Puzzle]: RenderedSolvedPuzzleMessage,
  [MessageType.Completed_Stage]: RenderedCompletedStageMessage,
  // Add other message types here...
};
